module.exports = __webpack_public_path__ + "static/01-ca2540b80183caa06581813d0e857a82.jpeg";